import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChangePasswordAuthRoutingModule } from './change-password-auth-routing.module';
import { ChangePasswordAuthComponent } from './change-password-auth/change-password-auth.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ToolsModule } from 'libs/portal/src/modules/tools/tools.module';
import { MatColComponent } from '../../../tools/mat-col/mat-col.component';
import { MatRowComponent } from '../../../tools/mat-row/mat-row.component';

@NgModule({
  declarations: [ChangePasswordAuthComponent],
  exports: [ChangePasswordAuthComponent],
  imports: [CommonModule, ChangePasswordAuthRoutingModule, ReactiveFormsModule, FormsModule, MaterialModule, ToolsModule, MatColComponent, MatRowComponent],
})
export class ChangePasswordAuthModule {}
